import RecordPreview from './RecordPreview';

export default RecordPreview;
export * from './RecordPreviewProps';
